import React from 'react'
import Layout from '../components/layout-global'
import Contact from '../components/contact'

const page = () => (
  <Layout centered>
    <Contact />
  </Layout>
)

export default page
